module.exports = __webpack_public_path__ + "4cdacb8f89d588d69e8570edcbe49507.ttf";